<div class="form-group">
  @if (showLabel && (question?.question_copy || question?.email_version)) {
    <label [innerHtml]="question?.question_copy || question?.email_version" class="form-group__label"></label>
  }
  @if (showSkip) {
    <div class="question-skip">
      <label class="custom-toggle custom-toggle--md custom-toggle--inline custom-toggle--transparent">
        <input
          type="checkbox"
          [checked]="skipped"
          [(ngModel)]="skipped"
          (ngModelChange)="onSkipChange()"
          name="add-note-toggle"
          id="skip-driver-details-toggle">
          <span class="custom-toggle__indi"></span>
          <span class="custom-toggle__label">Skip for now</span>
        </label>
      </div>
    }

    <div class="question__center-btn">
      <a href="javascript:;" (click)="locateMe()" class="button button--block button--primary button--lg" id="locate-me-btn">
        <svg class="icon"><use xlink:href="#geo-locate"></use></svg>
        Locate Me
      </a>
    </div>

    <div class="form-group mt-20 d-none" id="map-wrap">
      <label class="text-center">Drag the marker around to pin-point your location if necessary.</label>
      <div class="gmap gmap--lg" id="map-canvas" #gmap></div>
    </div>

    <div class="hr-or">or</div>

    <form [formGroup]="locationForm">
      <div class="address-fields">
        <div class="form-group form-group--sm">
          <input
            formControlName="apartmentNo"
            type="text"
            id="address_unit-1"
            placeholder="Apt / Unit No. (optional)"
            class="form-control"
            autocomplete="new-value" />
          </div>

          <div class="form-group form-group--sm">
            <input
              formControlName="complex"
              type="text"
              placeholder="Complex / Estate Name (optional)"
              class="form-control"
              autocomplete="new-value" />
            </div>

            <div class="form-group form-group--lg mb-15">
              <div class="form-control__wrap has-clear">
                <input type="search"
                  formControlName="streetAddress"
                  placeholder="Street Address"
                  autocomplete="new-value"
                  class="form-control"
                  autocapitalize="off"
                  spellcheck="false"
                  #addressText />
                  <a href="#" id="clear-address-1" class="form-control__clear">
                    <svg class="icon">
                      <use xlink:href="#close-circle-small"></use>
                    </svg>
                  </a>
                </div>
                <!--
                <div class="text-right mt-1">
                  <img src="assets/img/google-poweredby.svg" width="120" />
                </div> -->
              </div>

              <div class="form-group form-group--sm">
                <input
                  formControlName="suburb"
                  type="text"
                  id="address_suburb-1"
                  placeholder="Suburb"
                  class="form-control"
                  autocomplete="new-value" />
                </div>

                <div class="form-group form-group--sm">
                  <!--<select formControlName="province" (change)="changeProvince($event)" id="address_province-1" class="ui-selectmenu">
                  <option *ngFor="let item of provinces" [value]="item.id">{{item.value}}</option>
                </select>-->
                <app-question-dropdown
                  [options]="provinces"
                  [labelText]="'province'"
                  [selectedValue]="province"
                  (questionAnswer)="changeProvince($event)">
                </app-question-dropdown>
              </div>

              <div class="form-group form-group--sm">
                <input formControlName="city" type="text" id="address_city-1" placeholder="City" class="form-control" [autocomplete]="'newCit'" />
              </div>

              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group form-group--sm">
                    <input
                      formControlName="postalCode"
                      type="text"
                      id="address_postalcode-1"
                      placeholder="Postal Code"
                      class="form-control"
                      autocomplete="new-value" />
                    </div>
                  </div>
                </div>

              </div>
            </form>
          </div>